import { useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";

import { useMouseContent } from "src/utils/mouse/mouseContent";
import { Content_MST2010_R01 } from "./Content_MST2010_R01";
import { Info_MST2010_R01 } from "./Info_MST2010_R01";
import { SearchSection_MST2010_R01 } from "./SearchSection_MST2010_R01";
import { Table_MST2010_R01 } from "./Table_MST2010_R01";
import { useMST2010_R01Store } from "./Store_MST2010_R01";
import { AgGridReact } from "ag-grid-react";
import { MST2010_R01Dto } from "./Dto_MST2010_R01";

export const Container_MST2010_R01 = () => {

	const {  
		MST2010_R01Filter,
		MST2010_R01PastFilter,
		selectedMST2010_R01, editMST2010_R01,
		initData,
		} = useMST2010_R01Store();
	
	const { areaCdList, moneyCdList } = useCommonCodeStore();
	const { setMessage } = useUiuxStore();
	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: true,
		save: true,
		print: true,
		excel: true,
		init: false
	});
	const gridRef = useRef<AgGridReact<MST2010_R01Dto>>(null);

	// 선택된 고객이 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: !selectedMST2010_R01,
			save: !selectedMST2010_R01 && !editMST2010_R01.customCd,
			print: !selectedMST2010_R01,
			excel: !selectedMST2010_R01
		}));
	}, [selectedMST2010_R01, editMST2010_R01]);

	const RESIZER = {
		code: 'MST2010_R01',
		type: 'height',
		storageKey: 'MST2010_R01-split-height',
		min: 5,
		max: 80,
		default: 28
	} as const;
	const containerRef = useRef<HTMLDivElement>(null);
	
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef,
	});

	const {	
		handleExcelClick,
		fetchData,
		defaultMST2010_R01Row,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_MST2010_R01({
		gridRef,
		setMessage,
		
	});

	return (
	<div className="content-container">
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_MST2010_R01 />
		<div className="flex-1 flex flex-col p-[12px] gap-[4px]" ref={containerRef}>
			<div className="w-full" style={{ height: `${splitValue}%` }} ref={infoRef}>
				<Info_MST2010_R01 />
			</div>
			{/* 리사이저 */}
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent)}
				// 드래그 시작 방지
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
			/>
			<div className="w-full" style={{ height: `${100 - splitValue}%` }}>
				<Table_MST2010_R01 gridRef={gridRef} defaultMST2010_R01Row={defaultMST2010_R01Row()} />
			</div>
		</div>
		<Message />
	</div>

)

}